export default "__VITE_ASSET__c2487245__"